var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"reload-button elevation-0",class:_vm.extraClasses,attrs:{"loading":_vm.loading,"disabled":_vm.loading,"fab":"","x-large":_vm.xLarge,"large":_vm.large,"color":_vm.color}},[_c('v-icon',[_vm._v(" fa-redo ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }